import type { DefaultConfigOptions } from "@formkit/vue";
import { createProPlugin, datepicker, mask, taglist, repeater } from '@formkit/pro'
import { dragHandle, close, caretDown, caretDown as select, down, date, trash, arrowUp, arrowDown, add, file } from '@formkit/icons'
import { frequencyBandMatch, parkCodeFormat } from './formkit/validationRules';
import { createValidationPlugin } from '@formkit/validation';

const proPlugin = createProPlugin(import.meta.env.VITE_FORMKIT_PRO_KEY, {
  mask, datepicker, taglist, repeater
})

const validationPlugin = createValidationPlugin({
  frequencyBandMatch,
  parkCodeFormat
});

import { rootClasses } from "./formkit.theme";

const config: DefaultConfigOptions = {
  plugins: [proPlugin, validationPlugin],
  icons: { close, caretDown, dragHandle, down, select, date, trash, arrowUp, arrowDown, add, file },
  config: {
    rootClasses,

  },
  messages: {
    en: {
      ui: {
        summaryHeader: 'Errors:'
      }
    }
  }
};

export default config;
